/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { db } from "./config/firebaseWithFirestore";
import { loginSuccess } from "redux/actions/Login";
import { CssBaseline } from "@material-ui/core";
import { PersistGate } from "redux-persist/integration/react";
import Home from "components/Home";
import NotFound from "components/NotFound";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute";
import LoginRoute from "components/LoginRoute";
import ForgotPassword from "components/ForgotPassword";
import configStore from "./redux/store";
import FromOutsideWithToken from "components/FromOutsideWithToken";
import AppContext from "./AppContext";
import MessagingInitializer from "./MessagingInitializer";
import { initializeMessaging } from "config/firebaseWithFirestore";
import { Client } from "@twilio/conversations";
import { notifyInfo } from "redux/actions/Notifications";
import { getEnvVar } from "utils/env";
import { collection, query, where, limit, onSnapshot } from "firebase/firestore";

function SessionManager() {
    const { user } = useSelector((state) => state.Login);
    const {
        api: { Login },
    } = useContext(AppContext);

    useEffect(() => {
        let interval;
        if (user) {
            interval = window.setInterval(async () => {
                try {
                    await Login.check();
                } catch (error) {
                    console.log("Session check error", error);
                }
            }, 30000);
        }

        return () => Boolean(interval) && window.clearInterval(interval);
    }, [user]);

    return null;
}

function NotificationsMonitor() {
    const { user } = useSelector((state) => state.Login);
    const dispatch = useDispatch();

    const {
        api: {
            Chat: { ClientAccess },
        },
    } = useContext(AppContext);

    const initialize = async (forIdentity) => {
        const response = await ClientAccess.createAccessTokenAsync({ identity: forIdentity });
        if (response && response.data && typeof response.data === "string") {
            const token = response.data;
            if (token) {
                // Create the client
                const client = new Client(token, { logLevel: "error" });
                await initializeMessaging(client);
                client.on("pushNotification", (data) => {
                    console.log("Push notification received! ", data);
                    dispatch(notifyInfo(data.body));
                });
            }
        }
    };

    useEffect(() => {
        if (user) {
            // Twilio client for the logged-in user
            const identity = String(user.email).replace("@", "|_at_|");
            initialize(identity);

            // Twilio client for the company
            const companyIdentity = getEnvVar("REACT_APP_CHAT_IDENTITY");
            initialize(companyIdentity);
        }
    }, [user]);

    return null;
}

function Initializer(props) {
    const { user } = useSelector((state) => state.Login);

    const dispatch = useDispatch();

    useEffect(() => {
        let unsubscribe = () => {};

        if (user) {
            const ref = collection(db(), "settings_users");
            const qry = query(ref, where("email", "==", user.email), limit(1));
            unsubscribe = onSnapshot(qry, (snap) => {
                snap.docChanges().forEach((change) => {
                    if (change.type === "modified") {
                        dispatch(loginSuccess(change.doc.data()));
                    }
                });
            });
        }

        return () => unsubscribe();
    }, [user]);

    return (
        <PersistGate loading={null} persistor={configStore.persistor}>
            <CssBaseline />
            <SessionManager />
            <MessagingInitializer />
            <NotificationsMonitor />
            <Router>
                <Switch>
                    <LoginRoute exact path="/login" />
                    <Route exact path="/outside/t/:b64token" component={FromOutsideWithToken} />
                    <Route exact path="/forgot-password" component={ForgotPassword} />
                    <PrivateRoute path="/" component={Home} />
                    <Route component={NotFound} />
                </Switch>
            </Router>
        </PersistGate>
    );
}

export default Initializer;
